import { render } from "./base-layout.vue?vue&type=template&id=2a346e06&ts=true"
import script from "./base-layout.vue?vue&type=script&lang=ts"
export * from "./base-layout.vue?vue&type=script&lang=ts"

import "./base-layout.vue?vue&type=style&index=0&id=2a346e06&lang=less"

import exportComponent from "D:\\Projects\\aba\\aba-cabinet-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__